import React from 'react';
import { Flex} from "antd";
import {StyledCard} from "./SubCategoryPopup.styled";
import style from "./SubCategoryPopup.module.scss";
import {IoShieldCheckmark} from "react-icons/io5";
import {SubCategoryPopupCardProps} from "../../models";
import {FaChevronLeft} from "react-icons/fa6";
import {useNavigate} from "react-router-dom";

const SubCategoryPopupCard = ({title,id ,onClick,categoryId}: SubCategoryPopupCardProps) => {
const navigate = useNavigate()
    return (
        <StyledCard onClick={() => navigate("/product-list/"+categoryId+"/"+id , {state : {subCategoryTitle : title}})}>
            <Flex justify={"space-between"} align={"center"}>
                <span> {title} </span>
                <span> <FaChevronLeft   className={style.icons}/> </span>

            </Flex>
        </StyledCard>
    );
};

export default SubCategoryPopupCard;